<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2">
<p class="noindents"><em class="italic">To my friend Jean-Francois Remy Neris</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?dc194e4e